module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/spot01_point-1a0341f7f45378d64507e6ac58dadc05.jpg";